import React from "react";

import { connect } from "react-redux";

import Selector from "../../Selector";

import useStyles from "./styles";

const RoleField = ({
  selectedUser,
  groups,
  newUser,
  user,
  setType,
  oldUser,
  isDisabled,
  ...props
}) => {
  const classes = useStyles();

  const newUserType = newUser.type;
  const showRolesAccordingly = (profile) => {
    if (profile.includes("transporter") && profile.includes("user_admin")) {
      return [{ value: "transporter", label: "Transportadora" }];
    }
    return [
      { value: "transporter", label: "Gerente de Transportadora" },
      { value: "client", label: "Cliente" },
      { value: "driver", label: "Motorista" },
      { value: "check_in_agent", label: "Agente de Check In" },
      { value: "warehouse", label: "Armazém de Terceiros" },
      { value: "certifier", label: "Certificadora" },
      { value: "vendor", label: "Fornecedor" },
      { value: "farmer", label: "Fazenda" },
    ];
  };
  const showRolesAccordingToUserGroups = (type) => {
    if (type === "transporter" && !selectedUser.groups.includes("user_admin")) {
      return { value: "transporter", label: "Transportadora" };
    }

    if (type === "client") {
      return { value: "client", label: "Cliente" };
    }

    if (type === "check_in_agent") {
      return { value: "check_in_agent", label: "Agente de Check In" };
    }

    if (type === "transporter" && selectedUser.groups.includes("user_admin")) {
      return { value: "transporter", label: "Gerente Transportadora" };
    }
    if (type === "driver" && !selectedUser.groups.includes("user_admin")) {
      return { value: "driver", label: "Motorista" };
    }

    if (type === "warehouse") {
      return { value: "warehouse", label: "Armazém de Terceiros" };
    }

    if (type === "certifier") {
      return { value: "certifier", label: "Certificadora" };
    }

    if (type === "vendor") {
      return { value: "vendor", label: "Fornecedor" };
    }


    if (type === "farmer") {
      return { value: "farmer", label: "Fazenda" };
    }
  };

  return (
    <Selector
      label="Tipo de usuário"
      closeMenuOnSelect
      value={
        oldUser
          ? showRolesAccordingToUserGroups(selectedUser.type)
          : newUserType
      }
      isDisabled={isDisabled}
      isMulti={false}
      width="20rem"
      className={classes.field}
      isClearable={false}
      isSearchable={false}
      onChange={(data) => {
        setType({ key: "type", value: data });
      }}
      classNamePrefix="react-select"
      options={showRolesAccordingly(user.groups)}
      {...props}
      inputId="type-of-user-selector"
    />
  );
};

const mapState = (state) => ({
  newUser: state.users.newUser,
  groups: state.users.selectedUser.groups,
});
const mapDispatch = (dispatch) => ({
  setType: (payload) => dispatch.users.setNewUserAsync(payload),
});

export default connect(mapState, mapDispatch)(RoleField);
